import { useRef } from "react";
import { motion, useInView, useScroll, useTransform } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function MaskedLines({ lines, mode = "view", delay = 0, stagger = 0.12, className = "", lineClassName = "", as = "span" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  const active = mode === "load" || inView;
  const arr = Array.isArray(lines) ? lines : [lines];
  const Tag = as;
  return (
    <Tag ref={ref} className={`block ${className}`}>
      {arr.map((line, i) => (
        <span key={i} className="-mb-[0.1em] block overflow-hidden pb-[0.1em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "112%" }}
            animate={active ? { y: "0%" } : { y: "112%" }}
            transition={{ duration: 1, delay: (mode === "load" ? delay : 0) + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function ParallaxImage({ src, alt = "", className = "", caption, loading = "lazy" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  return (
    <figure ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        loading={loading}
        decoding="async"
        style={{ y }}
        className="absolute inset-0 h-full w-full scale-[1.15] object-cover"
      />
      {caption && (
        <figcaption className="absolute bottom-4 left-4 bg-ink/45 px-3 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-paper backdrop-blur-sm">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
